import { showToast } from '../../application/utils/toast.util';
import {validations} from '../../application/messages';
import {client} from '../../core/stores';
import {ExerciseProps, InputEvent} from '../../application/types';
import {MUTATION_EXERCISE} from '../../core/graphql/types';

// Assumindo que M é uma referência à Materialize global
declare const M: any;

export function MutationExercise(exercise: ExerciseProps, setSubmitting: InputEvent, setProgress: InputEvent): Promise<any> {
  return new Promise((resolve, reject) => {
    const {id, name, description, imageUrl, videoUrl, recordEnabled, exerciseType} = exercise as any;
    
    if(!name){
      showToast({html: 'Para salvar um exercício, você precisa preencher o nome', displayLength: 5000})
      reject(false);
      return false;
    }

    if(!description){
      showToast({html: 'Para salvar um exercício, você precisa preencher uma descrição/instruções', displayLength: 5000})
      reject(false);
      return false;
    }

    client('account').mutate({
      mutation: MUTATION_EXERCISE, 
      variables: {id, name, description, imageUrl, videoUrl, recordEnabled, exerciseType}
    })
    .then(response => {
      const {data} = response;
      const {setExercise: {exercise}} = data || {};
      console.log('MutationExercise ', response);
      showToast({html: 'Seu exercício foi salvo com sucesso!'});
      setSubmitting(false);
      resolve({status: 'success', exercise})
    })
    .catch(err => {
      const errorMessage = err.graphQLErrors.map((error: any) => error.message).join(',');
      showToast({ html: 'Houve um erro na sua solicitação.' })
      showToast({ html: errorMessage })
      setSubmitting(false);
      reject({status: 'error', message: errorMessage})
    });
  })
}